import React, { useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import Research from '../components/research-library';
import Filters from '../components/research-library/Filters';
import { toast } from '../../../components/Toasts';

import { changeResearchLibraryFilters, changeTickers, fetchResearchLibraryData } from '../actions';
import {
  reportsSelector,
  reportsFiltersSelector,
  reportsSettingsSelector,
  tickersSelector,
} from '../selectors';

import { filtersOptions, freeSampleReportId, isLoggedUser, permissions } from '../configs';
import { reportTypesOptions } from '../configs/research-library-config';
import api from '../api';

const reportCardStyle = {
  minWidthCard: 345,
  gap: 24,
};

const ResearchLibrary = () => {
  const dispatch = useDispatch();

  const reports = useSelector(reportsSelector);
  const reportsFilters = useSelector(reportsFiltersSelector);
  const settings = useSelector(reportsSettingsSelector);
  const tickers = useSelector(tickersSelector);

  const { type, pagination, eventId, filters } = reportsFilters;
  const disabledLibrary = !permissions.allowResearchLibrary;

  const handlePageChange = useCallback(
    ({ selected }) => {
      dispatch(
        changeResearchLibraryFilters({
          pagination: { ...pagination, page: selected + 1 },
          page: selected + 1,
        })
      );
      dispatch(fetchResearchLibraryData());
    },
    [pagination]
  );

  const handleTypeChange = useCallback((reportFilters) => {
    dispatch(changeResearchLibraryFilters(reportFilters));
  }, []);

  const handleTickersChange = useCallback((tickrs) => {
    dispatch(changeTickers(tickrs));
    api.researchLibrary.updateTickers({ tickers: tickrs }).then(() => {
      toast.success('Your email notification preferences have been saved.');
    });
  }, []);

  const handleFiltersChange = (filtersValue) => {
    dispatch(changeResearchLibraryFilters({ filters: filtersValue }));
    dispatch(fetchResearchLibraryData());
  };

  const resetEventId = useCallback(() => {
    dispatch(changeResearchLibraryFilters({ eventId: null }));
  }, []);

  const clearList = useCallback(() => {
    dispatch(changeResearchLibraryFilters({ type: reportTypesOptions(permissions)[0] }));
  }, []);

  // Efects
  // Initial fetch
  useEffect(() => {
    if (!reports.length) {
      dispatch(fetchResearchLibraryData());
    }
  }, []);

  return (
    <Research
      reports={reports}
      reportsFilters={reportsFilters}
      settings={settings}
      tickers={tickers}
      permissions={permissions}
      disabledLibrary={disabledLibrary}
      isLoggedUser={isLoggedUser}
      additionalsFilters={
        <div className="d-flex research-library-filters">
          <Filters
            filters={filters}
            handleChange={handleFiltersChange}
            resetSearchEvent={resetEventId}
            clearList={clearList}
            filtersOptions={filtersOptions}
            type={type}
            disabledLibrary={disabledLibrary}
            isLoggedUser={isLoggedUser}
            freeSampleReportId={freeSampleReportId ? parseInt(freeSampleReportId, 10) : 0}
            eventId={eventId}
            isLimitedFinanceAccess={permissions.isLimitedFinanceAccess}
          />
        </div>
      }
      reportCardStyle={reportCardStyle}
      onPageChange={handlePageChange}
      onTickersChange={handleTickersChange}
      onTypeChange={handleTypeChange}
    />
  );
};

export default ResearchLibrary;
